'use strict';

module.exports = ['Coat Check', 'Photo & Video', 'Valet Parking', 'Corkage Fee', 'Sommelier', 'Cheesemonger', 'Dessert Plating', 'Bartender', 'Dedicated Waitstaff'];